module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"products":"Products:","deleteConfirm":"Are you sure want to delete this notification?"},"et":{"products":"Products:","deleteConfirm":"Are you sure want to delete this notification?"},"ru":{"products":"Products:","deleteConfirm":"Are you sure want to delete this notification?"}}')
  delete Component.options._Ctor
}
